module.exports = __webpack_public_path__ + "media/images/fallback/product_square-9feaa07eea8dca828d148278e0562e3c.webp";